"use strict";
exports.__esModule = true;
var helpers_1 = require("./helpers");
exports.serializeParams = function (params) {
    return helpers_1.toPairs(params)
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        if (value == null) {
            return null;
        }
        return key + "=" + encodeURIComponent(value.toString());
    })
        .filter(helpers_1.identity)
        .join('&');
};
//# sourceMappingURL=query.js.map